import axios from 'axios'
import {apiUrl} from '@/api/base.js'

export default {
    get_all_plus (args) {
        return axios.get(`${apiUrl}v2/get_all_plus`,{ params: args })
    },
    get_plus_info (plusId) {
        return axios.get(`${apiUrl}v2/plus/${plusId}`)
    },
    join_plus (id) {
        return axios.post(`${apiUrl}v2/join_plus/${id}`)
    },
    set_plus_course_select (args) {
        return axios.post(`${apiUrl}v2/set_plus_course_select/`,{ params: args })
    },
    get_plus_course_select (args) {
        return axios.get(`${apiUrl}v2/get_plus_course_select/`,{ params: args })
    },
}
